@for (part of parts(); track part.id) {
  @switch (part.type) {
    @case ('text') {
      <markdown
        class="chat-part chat-part--text"
        [data]="part.text"
        clipboard
        (ready)="rendered.emit()" />
    }
    @case ('reasoning') {
      <details class="chat-part chat-part--reasoning">
        <summary class="chat-reasoning__summary">
          <i class="pi pi-lightbulb tw:text-sm"></i>
          <span>Thinking</span>
        </summary>
        <markdown
          [data]="part.text"
          (ready)="rendered.emit()" />
      </details>
    }
    @case ('tool') {
      <div
        class="chat-part chat-tool"
        [class.chat-tool--active]="isToolActive(part.state.status)"
        [class.chat-tool--completed]="part.state.status === 'completed'"
        [class.chat-tool--error]="part.state.status === 'error'">
        <div class="chat-tool__head">
          <i
            [class]="toolStatusIcon(part.state.status)"
            [class.pi-spin]="isToolActive(part.state.status)"></i>
          <span class="chat-tool__name">{{ toolLabel(part) }}</span>
          @if (isToolActive(part.state.status)) {
            <span class="chat-tool__status">Running...</span>
          }
          <div class="chat-tool__actions">
            <button
              test-id="ai-chat-message-parts-copy-output"
              type="button"
              class="chat-tool__action-btn"
              pTooltip="Copy output"
              tooltipPosition="top"
              (click)="copyToolOutput(part)">
              <i class="pi pi-copy"></i>
            </button>
            @if (hasToolDetails(part) && !isToolActive(part.state.status)) {
              <button
                test-id="ai-chat-message-parts-expand"
                type="button"
                class="chat-tool__action-btn"
                [pTooltip]="isExpanded(part.id) ? 'Collapse' : 'Expand'"
                tooltipPosition="top"
                (click)="toggleExpanded(part.id)">
                <i [class]="isExpanded(part.id) ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"></i>
              </button>
            }
          </div>
        </div>
        @if (hasToolDetails(part) && isExpanded(part.id)) {
          <div class="chat-tool__detail">
            @if (part.state.input) {
              <div class="chat-tool__label">Input</div>
              <pre class="chat-tool__code">{{ part.state.input | json }}</pre>
            }
            @if (part.state.output) {
              <div class="chat-tool__label">Output</div>
              <pre class="chat-tool__code">{{ part.state.output }}</pre>
            }
            @if (part.state.error) {
              <div class="chat-tool__label">Error</div>
              <pre class="chat-tool__code chat-tool__code--error">{{ part.state.error }}</pre>
            }
          </div>
        }
      </div>
    }
  }
}
